import { Box, Stack, Typography } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
// config
import colors from "../../../config/colors";
// utils
import {
  formatRelativeTime,
  formatNumberKMB,
  getAssetUrl,
} from "../../../utils/helpers";

const ContentTile = ({ item, ...props }) => {
  const fallbackImage = getAssetUrl("Placeholder.png");
  return (
    <Box
      key={item?.post_id}
      sx={{
        position: "relative",
        width: 104,
        height: 104,
        borderRadius: "4px",
        overflow: "hidden",
        cursor: "pointer",
      }}
      {...props}
    >
      <img
        src={item?.thumbnail_url || item?.media_url || fallbackImage}
        alt={item?.post_id}
        onError={(e) => {
          e.target.src = fallbackImage;
        }}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "4px",
          right: "4px",
          display: "flex",
          alignItems: "center",
          gap: "2px",
          backgroundColor: colors.primary100,
          padding: "0 4px 0 2px",
          borderRadius: "2px",
          height: "16px",
        }}
      >
        <InstagramIcon
          sx={{
            width: 12,
            height: 12,
            flexShrink: 0,
          }}
        />
        <Typography fontSize={10} lineHeight="16px">
          {item?.post_type}
        </Typography>
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "50%",
          background:
            "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.75) 100%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "8px",
          left: "8px",
        }}
      >
        <Stack gap="2px">
          <Stack direction="row" gap={0.5} alignItems="center">
            <VisibilityOutlinedIcon
              sx={{ width: 16, height: 16, color: colors.white, fontSize: 12 }}
            />
            <Typography fontSize={12} color={colors.white} lineHeight="16px">
              {formatNumberKMB(item?.total_views || item?.views)}
            </Typography>
          </Stack>
          <Typography fontSize={12} color={colors.white} lineHeight="16px">
            {formatRelativeTime(item?.post_created)}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default ContentTile;
